import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ServiceVersion } from '@app/shared/models/version-model';
import { AppData } from '@shared/models/appdata.model';
import { catchError, map } from 'rxjs/operators';
import { Environment } from '../models/environment.model';
import { Observable, of } from 'rxjs';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class UpdateService {
  private logger = inject(LoggerService);
  private appData = inject(AppData);
  private http = inject(HttpClient);

  getCurrentVersion(): Observable<string> {
    if (this.appData.environment === Environment.Development) {
      return of(this.appData.clientVersion);
    }
    const currentTime = new Date().getTime();
    const urlWithNoCache = `${this.appData.versionFile}?t=${currentTime}`;
    return this.http.get<ServiceVersion>(urlWithNoCache).pipe(
      map(response => response.currentVersion),
      catchError(error => {
        this.logger.error('Version check failed', error);
        return of(this.appData.clientVersion);
      })
    );
  }
}
